/**
 * 📊 BAR CHART WIDGET
 * ════════════════════════════════════════════════════════════════════════
 * 
 * Renderiza gráficos de barras (DRIVERS, comparaciones).
 * Simple, sin lógica adicional.
 */

import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import { getWidgetSeriesCache } from '../../../../shared/utils/seriesCache';
import { DataPoint } from '../../../../types/dashboard';

interface BarChartWidgetProps {
  widget: {
    id: string;
    title: string;
    data: DataPoint[];
    metadata?: any;
  };
}

const BarChartWidget: React.FC<BarChartWidgetProps> = ({ widget }) => {
  
  // Detectar campo X (dimensión) y Y (valor)
  const { detectedXField } = getWidgetSeriesCache({
    widgetId: widget.id,
    data: widget.data,
    defaultXField: 'category',
    defaultYField: 'valor',
  });
  const yField = 'valor';
  
  return (
    <div className="chart-widget">
      {/* Título */}
      <div className="chart-title">{widget.title}</div>
      
      {/* Gráfico */}
      <ResponsiveContainer width="100%" height="85%">
        <BarChart data={widget.data} margin={{ top: 10, right: 20, left: 0, bottom: 60 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#334155" opacity={0.3} />
          <XAxis 
            dataKey={detectedXField || 'category'} 
            tick={{ fill: '#94a3b8', fontSize: 11 }}
            stroke="#475569"
            angle={-45}
            textAnchor="end"
            height={60}
            interval={0}
          />
          <YAxis 
            tick={{ fill: '#94a3b8', fontSize: 12 }}
            stroke="#475569"
          />
          <Tooltip 
            contentStyle={{ 
              backgroundColor: '#1e293b', 
              border: '1px solid #334155',
              borderRadius: '8px'
            }}
            labelStyle={{ color: '#e2e8f0' }}
            itemStyle={{ color: '#0ea5e9' }}
          />
          <Bar dataKey={yField} fill="#0ea5e9" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BarChartWidget;
